export const APPNAME = 'Materials Data Exchange (MatEx)';
export const LOGGEDTEXT = 'Logged in User : ';
